import React from 'react';
import FinanceIcon from './ServiceSVG/financeSVG';
import StockIcon from './ServiceSVG/stockSVG';
import DocumentsIcon from './ServiceSVG/documentsSVG';
import ReportsIcon from './ServiceSVG/reportsSVG';
import CMRIcon from './ServiceSVG/cmrSVG';
import SchedulesIcon from './ServiceSVG/schedulesSVG';
import AutomatedRoutingIcon from './ServiceSVG/automatedRoutingSVG';
import VisualIdentityIcon from './ServiceSVG/visualIdentitySVG';
import WebsitesIcon from './ServiceSVG/websitesSVG';
import MarketingIcon from './ServiceSVG/marketingSVG';
import SocialMediaIcon from './ServiceSVG/socialMediaSVG';
import CertificateIcon from './ServiceSVG/certificateSVG';
import AppIcon from './ServiceSVG/appSVG';
import SoftwaresIcon from './ServiceSVG/softwaresSVG';

const SelectIcon = (props) => {
  const { icon, label, color } = props;
  const iconProps = {
    color,
    label,
  };
  let Icon;

  if (icon === 'finance') {
    Icon = <FinanceIcon {...iconProps} />;
  } else if (icon === 'stock') {
    Icon = <StockIcon {...iconProps} />;
  } else if (icon === 'reports') {
    Icon = <ReportsIcon {...iconProps} />;
  } else if (icon === 'documents') {
    Icon = <DocumentsIcon {...iconProps} />;
  } else if (icon === 'cmr') {
    Icon = <CMRIcon {...iconProps} />;
  } else if (icon === 'schedules') {
    Icon = <SchedulesIcon {...iconProps} />;
  } else if (icon === 'automatedRouting') {
    Icon = <AutomatedRoutingIcon {...iconProps} />;
  } else if (icon === 'visualIdentity') {
    Icon = <VisualIdentityIcon {...iconProps} />;
  } else if (icon === 'websites') {
    Icon = <WebsitesIcon {...iconProps} />;
  } else if (icon === 'Marketing') {
    Icon = <MarketingIcon {...iconProps} />;
  } else if (icon === 'socialMedia') {
    Icon = <SocialMediaIcon {...iconProps} />;
  } else if (icon === 'certificate') {
    Icon = <CertificateIcon {...iconProps} />;
  } else if (icon === 'app') {
    Icon = <AppIcon {...iconProps} />;
  } else if (icon === 'softwares') {
    Icon = <SoftwaresIcon {...iconProps} />;
  }

  return Icon;
};

export default SelectIcon;



// WEBPACK FOOTER //
// ./src/components/UI/Img/SelectService.jsx